import styled from 'styled-components';
import { fontBody, fontTitle } from 'Styles/fonts';
import breakpoint from 'Styles/breakpoints';
import ProductDescription from '../ProductDescription/ProductDescription';
import Layout from '../../../Layout/Layout';

export const Container = styled(Layout)`
  padding: 24px 24px 96px 24px;
  row-gap: 32px;

  ${breakpoint('medium', { mode: 'container' })} {
    padding-bottom: 24px;
  }
`;

export const DetailsBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  grid-column: 1 / -1;

  &:last-child {
    margin-bottom: 0;
  }

  & > :last-child {
    margin-bottom: 0;
  }

  list-style: disc;

  h1 {
    padding-bottom: 4px;
  }
`;

export const SectionTitle = styled.h2`
  ${fontTitle(20)};
  color: var(--foreground);
  padding-bottom: 4px;
`;

export const Description = styled(ProductDescription)`
  ${fontBody(16)};
  color: var(--foreground);
`;

export const Materials = styled.li`
  ${fontBody(16)};
  color: var(--foreground);
  text-transform: capitalize;
  padding-top: 4px;
  margin-left: 18px;
`;

export const CareInstructions = styled.p`
  ${fontBody(16)};
  color: var(--foreground);
`;

export const Imported = styled.p`
  margin: 0;
  ${fontBody(16)};
  color: var(--foreground);
  padding-top: 4px;
`;

export const Feature = styled.li`
  display: flex;
  align-items: center;
  ${fontBody(16)};
  color: var(--foreground);
  padding-top: 4px;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const TooltipContent = styled.p`
  max-width: 432px; /* Calculated max width of tooltip becomes 480px */
  width: calc(100vw - 64px);
  ${fontBody(14)};
`;
